/** Programs that remain selectable/authorable but are not income-only formula rows. */
export const ANCILLARY_ASSISTANCE_PROGRAM_IDS = [2, 5, 9, 11] as const

export function isAncillaryAssistanceProgram(programId: number): boolean {
  return (ANCILLARY_ASSISTANCE_PROGRAM_IDS as readonly number[]).includes(programId)
}

/** Keep the server catalog intact while omitting ancillary assistance from formula grids. */
export function visibleIncomeFormulaPrograms<T extends { programId: number }>(programs: readonly T[]): T[] {
  return programs.filter(program => !isAncillaryAssistanceProgram(program.programId))
}
